import React from "react"
import ReactDOM from "react-dom"
import ServiceContentContainer from "./service-content-container-component"

export default class ServiceContentContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ServiceContentContainer {...self.modelJson} />, self.elem)
  }
}
